import { Component, Input, OnDestroy, OnInit, inject, signal } from '@angular/core';

import { CasinoLobbyService } from '@casinocore/platform/core';
import { TeaserOnProductComponent } from '@casinocore/platform/teasers';
import { LaunchDarklyService } from '@frontend/vanilla/features/launch-darkly';
import { Subscription, take } from 'rxjs';

import { LobbyService } from '../../shared';
import { LaunchDarklyShowTeaserKey, TeaserSegment } from './teaser-launch-darkly.model';

@Component({
    selector: 'cs-teaser-section',
    templateUrl: 'teaser-section.component.html',
    imports: [TeaserOnProductComponent],
})
export class TeaserSectionComponent implements OnInit, OnDestroy {
    @Input() lobbyType: string;
    categoryChangeObs: Subscription;
    routeCurrentProduct: string;
    routeCategoryType: string;
    isTeaserFeatureEnabled = signal<boolean>(true);

    readonly teaserLDSegmentMap = new Map<number, boolean>([
        [TeaserSegment.SegmentA, true],
        [TeaserSegment.SegmentB, true],
    ]);

    lobbyService = inject(LobbyService);
    casinoLobbyService = inject(CasinoLobbyService);
    launchDarklyService = inject(LaunchDarklyService);

    ngOnInit() {
        this.categoryChangeObs = this.lobbyService.categoryChangeObservable.subscribe((productAndCat: any) => {
            if (productAndCat) {
                this.routeCurrentProduct = productAndCat.routeCurrentProduct;
                this.setRouteCategory(productAndCat.routeCategoryType);
            }
        });
        this.launchDarklyService
            .getFeatureFlagValue(LaunchDarklyShowTeaserKey, TeaserSegment.SegmentA)
            .pipe(take(1))
            .subscribe((teaserSegmentValue: number) => {
                const featureEnabled = this.teaserLDSegmentMap.get(teaserSegmentValue) ?? false;
                this.isTeaserFeatureEnabled.set(featureEnabled);
            });
    }
    ngOnDestroy() {
        if (this.categoryChangeObs) {
            this.categoryChangeObs.unsubscribe();
        }
    }

    setRouteCategory(routeCategory: string) {
        if (!routeCategory || routeCategory === '') {
            const defaultCatInfo: any = this.casinoLobbyService.getDefaultOrFirstCategoryInfo(this.lobbyType);
            if (defaultCatInfo && defaultCatInfo.categoryInfo) {
                this.routeCategoryType = defaultCatInfo.categoryInfo.categoryid;
            }
        } else {
            this.routeCategoryType = routeCategory;
        }
    }
}
